import React from "react";
import { default as Base, Tab } from "@gqlapp/base/Tabs";

export default (function Tabs(props){
	let { id, setFieldValue, values, items } = props || {}

	let value = values[id];

	let onTab = (items.length > 1);

	function onChange(name){
		return function onChange({}, newValue){
			setFieldValue(name, newValue);
		}
	}

	return <>
		{(!!onTab) && <>
			<Base value={value} onChange={onChange(id)} >
				{items.map(function (item, key){
					return (<Tab key={key} value={item.value}>{item.label}</Tab>)
				})}
			</Base>
		</>}

	</>
})